import { render, staticRenderFns } from "./FrameworkAppearance.vue?vue&type=template&id=58d5aeb8"
import script from "./FrameworkAppearance.vue?vue&type=script&lang=js"
export * from "./FrameworkAppearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports